<template>
  <div class="styles-renderLeftContent">
    <img loading="lazy" class="im-ele im-ele0" v-lazy="$common.getTitleLogo('animation1')" alt="">
    <img loading="lazy" class="im-ele im-ele1" v-lazy="$common.getTitleLogo('animation2')" alt="">
    <img loading="lazy" :class="`im-ele im-ele${index+2}`"
      v-for="(item, index) in images"
      :key="index"
      v-lazy="item.img"
    />
    <div
      class="styles-mouseHoverElementCover"
      @mousemove="handleMouseMove"
      @mouseleave="handleMouseLeave"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'app-cg-img',
  data() {
    return {
      isChange: true,
      images: [
        // { img: require("@/assets/images/amjs/animation1.png") },
        // { img: require("@/assets/images/amjs/animation2.png") },
        { img: require("@/assets/images/amjs/animation3.png") },
        { img: require("@/assets/images/amjs/animation4.png") },
        { img: require("@/assets/images/amjs/animation5.png") },
        { img: require("@/assets/images/amjs/animation6.png") },
        { img: require("@/assets/images/amjs/animation7.png") },
        { img: require("@/assets/images/amjs/animation8.png") },
      ]
    };
  },
  methods: {
    // 动画鼠标移入
    handleMouseMove(event) {
      document.querySelectorAll('.im-ele').forEach((item, index) => {
        let random = Math.random();
        let x = random + event.offsetX / 50,y = random + event.offsetY / 50;
        item.style.transform = `translate(${x}px, ${y}px) translateZ(0px)`;
        item.style.transitionDuration = '100ms';
      });
    },
    // 动画鼠标移除
    handleMouseLeave() {
      document.querySelectorAll('.im-ele').forEach((item, index) => {
        item.style.transitionDuration = '300ms';
        item.style.transform = 'translate(0,0) translateZ(0px)';
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.styles-renderLeftContent {
    width: 100%;
    height: 100%;
    position: relative;

    .im-ele {
        position: absolute;
        transition: transform 0.3s linear;
        transform: translate(0px, 0px) translateZ(0px);
        max-width: 100%;
        &.im-ele0 {
            top: 40px;
            left: 90px;
            height: 265px;
            z-index: 2;
        }
        &.im-ele1 {
            top: 40px;
            left: 155px;
            height: 265px;
            z-index: 2;
        }

        &.im-ele2 {
            top: 50px;
            left: 300px;
            width: 72px;
            display: none;
        }

        &.im-ele3 {
            bottom: 40px;
            left: 0;
            height: 220px;
            z-index: 3;
        }
        &.im-ele4 {
            bottom: 35px;
            left: 310px;
            height: 265px;
            z-index: 3;
        }

        &.im-ele5 {
            left: 65px;
            bottom: 40px;
            height: 35px;
        }

        &.im-ele6 {
            top: 10px;
            left: 110px;
            height: 320px;
            z-index: 2;
        }
        &.im-ele7 {
            bottom: 25px;
            left: 65px;
            height: 120px;
            z-index: 1;
        }
    }
}

.styles-mouseHoverElementCover {
    position: absolute;
    width: 750px;
    height: 530px;
    left: -70px;
    top: -60px;
    z-index: 50;
}
</style>
